// src/components/RequireConsent.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { hasDbConsent } from '../lib/policy';

export default function RequireConsent({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [ok, setOk] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) { setOk(true); return; } // לא מחוברים – אין מה לבדוק כאן
        const has = await hasDbConsent(supabase);
        setOk(has);
      } catch {
        setOk(false);
      }
    })();
  }, []);

  if (ok === null) return null; // אפשר לשים ספינר אם רוצים
  if (!ok) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/consent?next=${next}`} replace />;
  }
  return <>{children}</>;
}
